// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSplitFab-PrimaryButton_cls1__yUKMc","cls2":"VeloSplitFab-PrimaryButton_cls2__c9qja VeloSplitFab-PrimaryButton_cls1__yUKMc"};